(function () {
  'use strict';

  angular.module('ringbaPortal').component('liveCounterCell', {
    bindings: {
      usageStats: '<',
      caps: '<',
      isAmountType: '<',
      column: '<'
    },
    controller: LiveCounterCellController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/live-counter-cell/live-counter-cell.view.html'
  });

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });

  function LiveCounterCellController() {
    'ngInject';

    const vm = this;

    vm.$onChanges = onChanges;

    function onChanges() {
      _setUsageData();
    }

    function _setUsageData() {
      vm.capSetting = {};
      vm.capValue = 0;

      if (vm.usageStats && vm.usageStats[vm.column]) {
        vm.capValue = _formatCurrencyValue(vm.usageStats[vm.column]);
      }
      if (vm.caps) {
        switch (vm.column) {
        case 'currentLive':
        case 'currentLiveSum':
          vm.capSetting = vm.caps.live;
          break;

        case 'currentHour':
          vm.capSetting = vm.caps.hour;
          break;
        case 'currentHourSum':
          vm.capSetting = vm.caps.hourSum;
          break;

        case 'currentDay':
          vm.capSetting = vm.caps.day;
          break;
        case 'currentDaySum':
          vm.capSetting = vm.caps.daySum;
          break;

        case 'currentMonth':
          vm.capSetting = vm.caps.month;
          break;
        case 'currentMonthSum':
          vm.capSetting = vm.caps.monthSum;
          break;

        case 'total':
          vm.capSetting = vm.caps.total;
          break;
        case 'totalSum':
          vm.capSetting = vm.caps.totalSum;
          break;

        default:
          vm.usageData = null;
          break;
        }
      }
    }
    function _formatCurrencyValue(value) {
      return !Number.isInteger(value) ? currencyFormatter.format(value).replace('$', '') : value;
    }
  }
})();
